import { getCategoryDisplayIconUrl } from "../utils/categoryDisplayIcons";
import { getCategoryIcon, type Category } from "./CategoryMegaMenu";

export type CategoryDisplayIconProps = {
  category: Pick<Category, "name"> & Partial<Pick<Category, "slug" | "id">>;
  /** Wrapper (e.g. flex centering). */
  className?: string;
  /** Applied to `<img>` when a URL exists, or to the Lucide icon. */
  imgClassName?: string;
  /** Lucide icon classes when falling back (defaults to `imgClassName`). */
  iconClassName?: string;
};

/**
 * Renders the Alibaba-style category PNG when `name` matches the catalog; otherwise Lucide from `getCategoryIcon`.
 */
export function CategoryDisplayIcon({
  category,
  className = "",
  imgClassName = "h-5 w-5 object-contain shrink-0",
  iconClassName,
}: CategoryDisplayIconProps) {
  const url = getCategoryDisplayIconUrl(category.name);
  const iconCls = iconClassName ?? imgClassName;

  if (url) {
    return (
      <span
        className={`inline-flex shrink-0 items-center justify-center ${className}`.trim()}
        aria-hidden
      >
        <img
          src={url}
          alt=""
          className={imgClassName}
          loading="lazy"
          decoding="async"
          referrerPolicy="no-referrer-when-downgrade"
        />
      </span>
    );
  }

  const Icon = getCategoryIcon(category as Category);
  return <Icon className={iconCls} aria-hidden />;
}
